import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Approvalform, EmployeeAssesment, PromotionDto } from 'src/app/shared/models/appraisal';
import { Message } from 'src/app/shared/models/domain';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { CommonService } from 'src/app/shared/services/common.service';
@Component({
  selector: 'app-approval-promotable',
  templateUrl: './approval-promotable.component.html',
  styleUrls: ['./approval-promotable.component.scss']
})
export class ApprovalPromotableComponent implements OnInit {
  @Output() promotable = new EventEmitter<PromotionDto>();
  @Input() employeeAssesment: EmployeeAssesment;
  @Output() emitWizardIndex = new EventEmitter<number>();
  @Input() isActive : boolean;
  @Input() approvalStatus : boolean;
  public promotion: PromotionDto;
  public promotions: PromotionDto[];
  public promotionForm: FormGroup;
  private modified: boolean = false;
  public submitted: boolean = false;
  public isAssesmentCompleted: boolean = false;
  constructor(
    private appraisalServices: ApparaisalService,
    private commonService: CommonService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.isAssesmentCompleted = this.commonService.isAssesmentCompleted(this.employeeAssesment.status);
    this.setPromotionForm();
    this.getPromotions();
  }

  public setPromotionForm(promotion?: PromotionDto) {
    if (!promotion) promotion = {
      id: null,
      lastPromotion: null,
      previouslyRejected: false,
      reasonToPromote: null,
      reasonNotToPromote: null,
      achievements: null,
      swot: null,
      skills: null,
      techStack: null,
      title: null,
      roles: null,
      assessmentId: this.employeeAssesment.id,
      status: 'LONE_PROMOTABLE',
      promotable: false,
    } as PromotionDto
    this.promotionForm = this.fb.group({
      id: this.fb.control(promotion?.id),
      lastPromotion: this.fb.control(promotion?.lastPromotion || Date, []),
      previouslyRejected: this.fb.control(promotion?.previouslyRejected, []),
      reasonToPromote: this.fb.control(promotion?.reasonToPromote, []),
      reasonNotToPromote: this.fb.control(promotion?.reasonNotToPromote, []),
      achievements: this.fb.control(promotion?.achievements, []),
      swot: this.fb.control(promotion?.swot, []),
      skills: this.fb.control(promotion?.skills, []),
      techStack: this.fb.control(promotion?.techStack, []),
      title: this.fb.control(promotion?.title, []),
      roles: this.fb.control(promotion?.roles, []),
      assessmentId: this.fb.control(promotion?.assessmentId, []),
      status: this.fb.control(promotion?.status, []),
      promotable: this.fb.control(promotion?.promotable, [Validators.required]),
    });
  }
  public savePromotion(): void {
    if (this.isActive) {
      return;
    }
  
    if (this.promotionForm.valid) {
      const promotion: PromotionDto = this.promotionForm.value as PromotionDto;
      const isPromotable = promotion.promotable === true; 
  
      if (promotion?.id) {
        if (isPromotable) {
          this.appraisalServices.updatePromotion(promotion.id, promotion).subscribe({
            next: (message: Message) => {
              if (!message.failed) {
                this.emitWizardIndex.emit(5);
              } else {
                this.commonService.setToastr(500, message.text);
              }
            },
            error: (err: any) => {
              this.commonService.setToastr(500, "Failed to Update Promotion");
            }
          });
        } else {
          this.employeeAssesment.status = "LONE_PROMOTABLE";
          this.appraisalServices.updateApprovalForm(this.employeeAssesment.id, this.employeeAssesment).subscribe({
            next: (response: Message) => {
              if (!response.failed) {
                this.emitWizardIndex.emit(5);
              }
            },
            error: (error: HttpErrorResponse) => {
              this.commonService.setToastr(500, "Failed to Update Approval Form");
            }
          });
        }
      } else {
        if (isPromotable) {
          this.appraisalServices.createPromotion(promotion).subscribe({
            next: (message: Message) => {
              if (!message.failed) {
                this.commonService.setToastr(200, message.text);
                this.emitWizardIndex.emit(5);
              } else {
                this.commonService.setToastr(500, message.text);
              }
            },
            error: (err: any) => {
              this.commonService.setToastr(500, "Failed to Create Promotion");
            }
          });
        } else {
          this.employeeAssesment.status = "LONE_PROMOTABLE";
          this.employeeAssesment.promotable = false;
          this.appraisalServices.updateApprovalForm(this.employeeAssesment.id, this.employeeAssesment).subscribe({
            next: (response: Message) => {
              if (!response.failed) {
                this.emitWizardIndex.emit(5);
              }
            },
            error: (error: HttpErrorResponse) => {
              this.commonService.setToastr(500, "Failed to Update Approval Form");
            }
          });
        }
      }
    } else {
      this.commonService.setToastr(400, "Please enter the promotion");
    }
  }
  
  public getPromotions() {
    if (this.employeeAssesment.id) {
      this.appraisalServices.getPromotions(this.employeeAssesment.id).subscribe({
        next: (promotions: PromotionDto[]) => {
          this.promotions = promotions;
          if (promotions && promotions.length > 0) {
            this.setPromotionForm(promotions[0]);
          }
        },
         error: (error: HttpErrorResponse) => {
        }
      });
    }
  }
}
